var AdaptiveImage = require("../node_modules/react-native-web-image-loader/lib/modules/adaptiveImage.js").default;

module.exports = new AdaptiveImage({
    uri: __webpack_public_path__ + "checkmark.1ba251d4.png","uri@2x": __webpack_public_path__ + "checkmark.abade6c3.png","uri@3x": __webpack_public_path__ + "checkmark.dfaa2c89.png",
    width: 26,
    height: 20
});